import { selector } from "recoil";
import { editAuditNumber, unitAdminEditData, unitIndex } from "./atoms";
import axios from "axios";
import { getToken } from "../components/auth/authConfig";

const queryParams = new URLSearchParams(window.location.search);
const auditNumber = queryParams.get("auditNumber");

export const editData = selector({
  key: "editData",
  get: async ({ get }) => {
    // alert("selector calling")
    // const data = get(unitAdminEditData);
    const token = await getToken();
    if (auditNumber) {
      // alert("calling api")
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/form/ud/${auditNumber}`;
      try {
        const { data } = await axios.get(apiUrl, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
        if (data) {
          // console.log("true");
          const editDataLayout = {
            unitDetails: data?.unitDetails,
            offSiteFields: data?.offSiteFields,
          };
          //   console.log("this one", editDataLayout);
          return editDataLayout;
        }
      } catch (e) {
        console.log("error while getting the form data");
      }
    } else {
      return null;
    }
  },
});

export const AutoPopulate = selector({
  key: "AutoPopulate",
  get: async ({ get }) => {
    const token = await getToken();
    const unitIndexValue = get(unitIndex);
    if (unitIndexValue) {
      // alert("calling api")
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/api/auto-populate/unitdetails`;
      try {
        const { data } = await axios.post(
          apiUrl,
          {
            unitIndex: unitIndexValue,
          },
          {
            headers: {
              "oidc-token": token,
              Accept: "application/json",
            },
          }
        );
        if (data) {
          if (Object.keys(data).length > 0) {
            alert("haha")
          }
          // console.log("true");
          const editDataLayout = {
            unitDetails: data?.unitDetails,
            offSiteFields: data?.offSiteFields,
          };
          //   console.log("this one", editDataLayout);
          return editDataLayout;
        }
      } catch (e) {
        console.log("error while getting the form data");
      }
    } else {
      return null;
    }
  },
});
